import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { formatMatchDay } from "./newsletterFormat";

export function NewsletterCallForPlayers({ calls, href = "/competition" }) {
  const { t, i18n } = useTranslation();
  if (!calls?.length) return null;
  return (
    <section className="pingflo-call" aria-labelledby="pingflo-call-title">
      <h2 id="pingflo-call-title">{t("newsletterCallTitle", "Players needed")}</h2>
      <ul>
        {calls.map((call) => (
          <li key={call.fixture_id}>
            <strong>
              {t("newsletterCallNeeded", {
                count: Number(call.needed) || 0,
                defaultValue: "{{count}} more player(s)",
              })}
            </strong>
            <span>
              {call.team_name} {t("newsletterVs", "vs")} {call.opponent_name}
            </span>
            <span className="pingflo-call-when">
              {formatMatchDay(call.date, i18n.language)}
              {call.time ? ` · ${call.time}` : ""}
            </span>
          </li>
        ))}
      </ul>
      <Link className="pingflo-call-cta" to={href}>
        {t("newsletterAvailable", "I'm available")}
      </Link>
    </section>
  );
}
